'use client';

import { useEffect, useState } from 'react';
import { getUploadPresignedUrls } from '@/app/apis';
import { isDirectDisplayImageUrl, isSsuploadUri } from '../utils';

export async function resolveAvatarDisplayImage(uri: string): Promise<string> {
  const trimmed = uri.trim();
  if (!trimmed) {
    return '';
  }

  if (isDirectDisplayImageUrl(trimmed)) {
    return trimmed;
  }

  if (!isSsuploadUri(trimmed)) {
    return trimmed;
  }

  const { data, error } = await getUploadPresignedUrls({
    body: {
      uris: [trimmed],
    },
  });

  if (error) {
    return '';
  }

  return data?.presigned_urls?.[trimmed]?.trim() ?? '';
}

export function useAvatarDisplayImage(rawUri: string): string {
  const [displayUri, setDisplayUri] = useState(() => (isDirectDisplayImageUrl(rawUri) ? rawUri.trim() : ''));

  useEffect(() => {
    const trimmed = rawUri.trim();
    if (!trimmed) {
      setDisplayUri('');
      return;
    }

    if (isDirectDisplayImageUrl(trimmed)) {
      setDisplayUri(trimmed);
      return;
    }

    let cancelled = false;
    setDisplayUri('');

    resolveAvatarDisplayImage(trimmed).then((resolved) => {
      if (!cancelled) {
        setDisplayUri(resolved);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [rawUri]);

  return displayUri;
}
